import { ruleFeature } from './rule.reducer';

const { selectRules } = ruleFeature;

export const RuleSelectors = {
  selectRules,
};
